import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge, BadgeType } from '@components/atoms/Badge';
import { AdherenceState } from '@types';

interface AdherenceStateBadge {
    state: AdherenceState;
}

export const AdherenceStateBadge: FC<AdherenceStateBadge> = ({ state }) => {
    const { t } = useTranslation();

    const translations = {
        pending: t('adherences-state.pending'),
        accepted: t('adherences-state.accepted'),
        rejected: t('adherences-state.rejected')
    };

    switch (state) {
        case AdherenceState.pending:
            return <Badge label={translations.pending} type={BadgeType.limeGreen} icon="fa-light fa-gear" />;
        case AdherenceState.accepted:
            return <Badge label={translations.accepted} type={BadgeType.success} icon="fa-light fa-check" />;
        case AdherenceState.rejected:
            return <Badge label={translations.rejected} type={BadgeType.danger} icon="fa-light fa-xmark" />;
        default:
            <></>;
    }
};
